document.addEventListener("DOMContentLoaded", () => {
    const customerTermContent = document.querySelector("#customer-term-content");

    if(!customerTermContent){
      return;
    }

    // 無効化するキー一覧
    const blockedKeys = [
      { ctrlKey: true, shiftKey: true, key: 'J' },//for Windows
      { ctrlKey: true, shiftKey: true, key: 'I' },
      { ctrlKey: true, shiftKey: true, key: 'Z' },
      { ctrlKey: true, shiftKey: true, key: 'K' },
      { ctrlKey: true, shiftKey: true, key: 'E' },
      { ctrlKey: true, shiftKey: true, key: 'C' },
      { ctrlKey: true, shiftKey: true, key: 'P' },
      { ctrlKey: true, key: 'c' },
      { ctrlKey: true, key: 'x' },
      { ctrlKey: true, key: 'v' },
      { ctrlKey: true, key: 'a' },
      { ctrlKey: true, key: 's' },
      { ctrlKey: true, key: 'p' },
      { ctrlKey: true, key: 'u' },
      { ctrlKey: true, key: 'f' },
      { ctrlKey: true, key: 'h' },
      { ctrlKey: true, key: 'r' },
      { metaKey: true, altKey: true, key: 'J' },//for Mac
      { metaKey: true, altKey: true, key: 'I' },
      { metaKey: true, altKey: true, key: 'Z' },
      { metaKey: true, altKey: true, key: 'K' },
      { metaKey: true, altKey: true, key: 'E' },
      { metaKey: true, altKey: true, key: 'C' },
      { metaKey: true, altKey: true, key: 'U' },
      { metaKey: true, key: 'c' },
      { metaKey: true, key: 'x' },
      { metaKey: true, key: 'v' },
      { metaKey: true, key: 'a' },
      { metaKey: true, key: 's' },
      { metaKey: true, key: 'p' },
      { metaKey: true, key: 'u' },
      { metaKey: true, key: 'f' },
      { metaKey: true, key: 'h' },
      { metaKey: true, key: 'r' },
      { shiftKey: true, key: 'F5' },//common
      { shiftKey: true, key: 'F7' },
      { shiftKey: true, key: 'F9' },
      { key: 'F12' }
    ];

    customerTermContent.addEventListener("copy", (e) => {
        e.preventDefault();
    });

    customerTermContent.addEventListener("contextmenu", (e) => {
        e.preventDefault();
    });

    window.addEventListener('keydown', function(e) {
      const isBlocked = blockedKeys.some(function(condition) {
          return (condition.ctrlKey === undefined || condition.ctrlKey === e.ctrlKey) &&
              (condition.shiftKey === undefined || condition.shiftKey === e.shiftKey) &&
              (condition.altKey === undefined || condition.altKey === e.altKey) &&
              (condition.metaKey === undefined || condition.metaKey === e.metaKey) &&
              condition.key === e.key;
      });
      if (isBlocked) {
          e.preventDefault();
      }
    });
});
